import { translationModeration_da } from "./translationModeration.da";
import { translationModeration_en } from "./translationModeration.en";
import { translationModeration_sv } from "./translationModeration.sv";
import { defineDashboardTranslations } from "./translationTypes";

/** Moderation flags, visitor blocks and the Blocked visitors page. */
export const translationModeration = defineDashboardTranslations({
  da: translationModeration_da,
  en: translationModeration_en,
  sv: translationModeration_sv,
});
